var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNavigationArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.4766 13.599L14.475 11.6603L10.3065 7.50027L14.4681 3.33993L14.4665 1.40112L8.36558 7.50027L14.4766 13.599ZM10.4649 11.6603L10.4665 13.599L4.35554 7.50027L10.4565 1.40112L10.4581 3.33993L6.29651 7.50027L10.4649 11.6603ZM6.63136 11.6603L6.63295 13.599L0.521967 7.50027L6.62292 1.40112L6.62452 3.33993L2.46294 7.50027L6.63136 11.6603Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavigationArrowLeft);
export default __webpack_public_path__ + "static/media/navigation_arrow_left.400e6f3f911f703e62489fbc581a20e5.svg";
export { ForwardRef as ReactComponent };